<!--
@Author: MIYONGLE
@Desc: 移动端侧边栏
@Date: 2021-07-27 14时
-->
<template>
  <div class="m-side-bar">
    <span class="free-text" @click="sendMsg">免<br>费<br>体<br>验</span>
    <div class="side-bar-iphone">
      <span class="free-text" @click.stop="isPopup = !isPopup">电<br>话<br>咨<br>询</span>
      <transition name="fade">
        <a @click="xhrCallPhone" class="modalDiaLog" v-if="isPopup" href="tel:400-085-5500">400-085-5500</a>
      </transition>
    </div>
  </div>
</template>

<script type="text/javascript">
  import {getCallOc} from "../service/apis";
  import {HTTP_CODE} from "../service/axios_constants";
  export default {
    name: "mSidebar",
    data() {
      return {
        isPopup: false
      }
    },
    
    components: {
    },

    created() {

    },

    mounted () {
      // 点击其他地方弹窗消失
      document.addEventListener('click', (e)=> {
        if (e.target.className != 'modalDiaLog') {
          this.isPopup = false;
        }
      })
    },

    methods: {

      // 兄弟传值
      sendMsg() {
        eventBus.$emit("operaDiaLog", true);
        eventBus.$emit("sourceF", false);
      },

      // 拨打电话
      xhrCallPhone(){
        getCallOc().then(res=>{
          if (res.statusCode === HTTP_CODE.suc) {
            window.location.href = 'tel:400-085-5500';
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

  //隐藏到显示过程所需要的时间
  .fade-enter-active{     
    transition: opacity .5s;     
  }

  //初始化状态
  .fade-enter {          
    opacity: 0;
  }

  // 侧边栏
  .m-side-bar{
    position: fixed;
    right: 30px;
    top: 50%;
    z-index: 2;
    .free-text{
      width: 80px;
      // height: 160px;
      background: #1985FF;
      box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      display: block;
      font-size: 22px;
      color: #FFFFFF;
      text-align: center;
      padding: 20px 0;
      box-sizing: border-box;
    }

    //电话
    .side-bar-iphone{
      margin-top: 20px;
      position: relative;
      a{
        width: 409px;
        height: 126px;
        background: #FFFFFF;
        box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.2);
        display: block;
        border-radius: 16px;
        font-size: 36px;
        color: #1985FF;
        line-height: 126px;
        position: absolute;
        top: 20px;
        right: 90px;
      }

      a::after{
        content: ' ';
        display: block;
        width:0; 
        height:0;
        border-width:50px;
        border-style:solid;
        border-color: transparent transparent transparent #fff;
        position: absolute;
        top: 10px;
        right: -70px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/mSidebar.vue